import { CART_SHIPPING_MODEL_VIEW, Utilities, type Cart } from 'core/domains';

export const initialState: Cart = {
  data: {} as Cart['data'],
  canAddItem: false,
  canSubmit: false,
  canSubmitShippingModel: false,
  shippingModelHasBeenSelected: false,
  comboEditConfirmation: {
    isOpen: false,
    comboCode: 0,
  },
  couponUpdate: {
    meta: {},
    message: '',
    status: Utilities.STATUS.IDLE,
  },
  current: {
    code: '',
    distributionCenterAddress: '',
    shippingModel: {
      changeDeliveryMode: true,
      iswithdrawal: false,
    },
    userCredit: '',
  },
  deleteConfirmation: {
    data: {} as Cart['deleteConfirmation']['data'],
    isOpen: false,
  },
  minOrderConfirmation: {
    isOpen: false,
  },
  fetch: {
    message: '',
    status: Utilities.STATUS.IDLE,
  },
  hasBeenCalled: false,
  shippingModelNotFound: false,
  hasItem: false,
  itemUpdate: {
    message: '',
    meta: {} as Cart['itemUpdate']['meta'],
    status: Utilities.STATUS.IDLE,
  },
  isRunning: false,
  step: CART_SHIPPING_MODEL_VIEW.OPTIONS,
  updatedAt: 0,
};
